module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"HeaderMainHook":{"freeShipping":"Doprava zdarma nad {price}"}},"de":{"HeaderMainHook":{"freeShipping":"Kostenloser Versand über {price}"}},"sk":{"HeaderMainHook":{"freeShipping":"Doprava zadarmo nad {price}"}}}')
  delete Component.options._Ctor
}
